var exports = {
  "kL": "x2b2fbebb--647aa5--container",
  "DD": "x2b2fbebb--647aa5--title",
  "uf": "x2b2fbebb--647aa5--stars",
  "kM": "x2b2fbebb--647aa5--stars-item",
};

module.exports = exports;
